import { Callout } from '@/components/UI';
import { describeRunExposure, type IdeaLabRunExposure } from '../ideaLabUtils';

interface RunExposureCalloutProps {
    exposure: IdeaLabRunExposure;
    run: { endDateTime: string; walkForwardStartDateTime: string | null };
}

/** States above a report how much of its evidence the study has already looked at. */
const RunExposureCallout = ({ exposure, run }: RunExposureCalloutProps) => {
    const { body, detail } = describeRunExposure(exposure, run);

    return (
        <Callout title="Exploratory results" variant="warning">
            <p>{body}</p>
            <p className="mt-1 text-xs text-zinc-400">{detail}</p>
        </Callout>
    );
};

export default RunExposureCallout;
